import { css } from 'react-emotion'

const divider = css`
  box-shadow: 0 1px rgba(99,114,130,0.16);
`

export default divider


// WEBPACK FOOTER //
// ./src/theme/styles/divider.js